import { AwsS3Icon, GoogleDriveIcon } from '../../../../assets/images';
import { ActionModal } from '../../../../components';
import { folderSelectionModalConfig } from '../data/constants';
import { FolderSelectionModalConfig } from '../kb.props';
import FolderTree from './folder-tree';

function FolderSpecificModal({
  isOpen,
  setIsOpen,
  service,
  data,
  isLoading,
  folderId,
}: FolderSelectionModalConfig) {
  const getTilesIcon = () => {
    switch (service) {
      case 'G-drive':
        return GoogleDriveIcon;
      default:
        return AwsS3Icon;
    }
  };

  const modalConfig = folderSelectionModalConfig?.find((cfg) => cfg.id === service);

  return (
    <ActionModal
      className="w-[450px]"
      open={isOpen}
      cancelButtonNeeded={false}
      resetData={() => {
        setIsOpen(false);
      }}
      saveData={() => {
        setIsOpen(false);
      }}
      confirmButtonText="Close"
      modalLogo={getTilesIcon()}
      modalTitle={<h3 className="text-base font-bold">{modalConfig?.Title || 'pp'}</h3>}
      modalDesc={modalConfig?.description}
    >
      <div className="mt-1">
        <FolderTree
          loading={isLoading}
          folderId={folderId}
          service={service}
          data={data}
          showCheckboxes={false}
        />
      </div>
    </ActionModal>
  );
}

export default FolderSpecificModal;
